import styled from 'styled-components';
export default styled.div`
  margin: ${props => props.theme.formGroupMargin};
`;
//# sourceMappingURL=styles.js.map